export const inArray = (state) => Object.values(state.list);
export const byUuid = (state, getters) => (uuid) => getters.inArray.find((val) => val.uuid == uuid);
export const showOrder = (state, getters) => state.order;
